/* My Garage Feature - Non Collection Pages */
function parseCookieString(e) {
  return e.split(";").reduce(function (e, t) {
    let i = t.split("=");
    return (e[i.shift().trim()] = decodeURI(i.join("="))), e;
  }, {});
}
function triggerRefreshLinks() {
  let e = parseCookieString(document.cookie);
  if (
    document.cookie
      .split(";")
      .some((e) => e.trim().startsWith("myActiveGarage="))
  ) {
    let t = JSON.parse(e.myActiveGarage || "[]"),
      i = document.querySelectorAll(
        '.header__linklist-item[data-item-title="SHOP BY CATEGORY"] a, .header__linklist-item[data-item-title="SHOP BY PRODUCTS"] a, .vehicle-filter-links'
      ),
      r = new URL(window.location.href),
      a = r.searchParams;
    var l =
      "?filter.p.m.vehicle.compatibility=" +
      (t = t.toString().replace(/ /g, "+"));
    a.forEach((e, t) => {
      ("filter.v.price.lte" == t ||
        "filter.v.price.gte" == t ||
        "sort_by" == t ||
        "filter.p.tag" == t) &&
        (l = l + "&" + t + "=" + e);
    }),
      (i ?? []).forEach((e) => {
        let t = new URL(e.href);
        (t.search = ""), (e.href = t.href + l);
      });
  }
}
/* END My Garage Feature - Non Collection Pages */

/* PickPack recommendations: re-rank the server-rendered list for the active
   My Garage vehicle and the cart. Candidates arrive hidden beyond the first N;
   this promotes the ones that fit the customer's car, drops anything already in
   the cart, and reveals N. Parts listing the vehicle come first, then universal
   parts and parts with no fitment list, then parts made for other cars. When the
   page's own product does not fit the garage vehicle the server order is kept. */
(function () {
  if (window.customElements && !window.customElements.get("pickpack-recommendations")) {
    class PickPackRecommendations extends HTMLElement {
      connectedCallback() {
        this.rerank();
        this._onGarage = () => this.rerank();
        document.addEventListener("mygarage:change", this._onGarage);
      }
      disconnectedCallback() {
        document.removeEventListener("mygarage:change", this._onGarage);
      }
      activeVehicle() {
        var norm = function (v) { return String(v || "").toUpperCase().replace(/\s+/g, " ").trim(); };
        try {
          var cookies = parseCookieString(document.cookie);
          var garage = JSON.parse(cookies.myActiveGarage || "[]");
          if (Array.isArray(garage) && garage.length) return norm(garage[0]);
        } catch (e) {}
        try {
          var ctx = window.sessionStorage && window.sessionStorage.getItem("myGarageContextVehicle");
          if (ctx) {
            try { var parsed = JSON.parse(ctx); ctx = Array.isArray(parsed) ? parsed[0] : (parsed && parsed.vehicle) || parsed; } catch (e) {}
            if (typeof ctx === "string") return norm(ctx);
          }
        } catch (e) {}
        return "";
      }
      rerank() {
        var count = parseInt(this.getAttribute("recommendations-count") || "4", 10) || 4;
        var vehicle = this.activeVehicle();
        var norm = function (v) { return String(v || "").toUpperCase().replace(/\s+/g, " ").trim(); };
        // A page for a part that does not fit the garage vehicle means the customer
        // is shopping for another car, so keep the list's own order.
        if (vehicle) {
          var own = [];
          try { own = JSON.parse(this.getAttribute("data-product-fitment") || "[]") || []; } catch (e) {}
          if (!Array.isArray(own)) own = [];
          own = own.map(norm);
          if (own.length && own.indexOf(vehicle) === -1 && own.indexOf("UNIVERSAL FIT") === -1) vehicle = "";
        }
        var items = Array.prototype.slice.call(this.querySelectorAll(".pp-rec")).map(function (el) {
          var fitment = [];
          try { fitment = JSON.parse(el.getAttribute("data-fitment") || "[]") || []; } catch (e) {}
          if (!Array.isArray(fitment)) fitment = [];
          // 2 = lists the vehicle, 1 = universal or no fitment data, 0 = made for other cars.
          var listed = fitment.map(norm);
          var fits = 1;
          if (vehicle) {
            if (listed.indexOf(vehicle) !== -1) fits = 2;
            else if (listed.length && listed.indexOf("UNIVERSAL FIT") === -1) fits = 0;
          }
          return {
            el: el,
            card: el.firstElementChild,
            rank: parseInt(el.getAttribute("data-rank") || "999", 10),
            fits: fits,
            inCart: el.hasAttribute("data-in-cart")
          };
        });
        var eligible = items.filter(function (i) { return !i.inCart; }).sort(function (a, b) {
          return (b.fits - a.fits) || (a.rank - b.rank);
        });
        var shown = 0;
        eligible.forEach(function (i, index) {
          var visible = index < count;
          i.el.toggleAttribute("data-hidden", !visible);
          if (i.card) i.card.style.order = String(index);
          if (visible) shown++;
        });
        items.filter(function (i) { return i.inCart; }).forEach(function (i) { i.el.setAttribute("data-hidden", ""); });
        this.hidden = shown === 0;
      }
    }
    window.customElements.define("pickpack-recommendations", PickPackRecommendations);
  }
})();

/* Fitment accordion: a long fitment table in a product description is shown
   as one collapsible item per vehicle, replacing the table (and its one card
   per row on phones). The table stays in the description and is edited as
   before; the accordion is built from it on load and the table is hidden.
   Only tables given the class table-accordion are converted. Rows are grouped
   by the first column; a blank first cell means the row belongs to the
   vehicle above, as the table reads on desktop. */
(function () {
  function text(cell) { return cell ? cell.textContent.replace(/\s+/g, " ").trim() : ""; }
  function label(heading) { return heading.charAt(0).toUpperCase() + heading.slice(1).toLowerCase(); }

  function readTable(table) {
    var headers = Array.prototype.map.call(table.querySelectorAll("thead th"), text);
    if (headers.length < 2) return null;
    var groups = [];
    var previous = [];
    table.querySelectorAll("tbody tr").forEach(function (tr) {
      var cells = Array.prototype.map.call(tr.querySelectorAll("td"), text);
      if (!cells.some(Boolean)) return;
      // A blank second cell (Y33 4WD under Y33 2WD) repeats the one above too.
      var row = headers.map(function (_, i) { return i < 2 && !cells[i] ? previous[i] || "" : cells[i] || ""; });
      var group = groups[groups.length - 1];
      if (!group || group.name !== row[0]) groups.push(group = { name: row[0], rows: [] });
      group.rows.push(row.slice(1));
      previous = row;
    });
    if (!groups.length) return null;
    return { headers: headers.slice(1), groups: groups };
  }

  function build(table, data) {
    var wrapper = table.closest(".table-wrapper") || table;
    var accordion = document.createElement("div");
    accordion.className = "fitment-accordion";
    data.groups.forEach(function (group) {
      var item = document.createElement("details");
      item.className = "fitment-accordion__item";
      var summary = document.createElement("summary");
      summary.className = "fitment-accordion__summary";
      summary.textContent = group.name || "Other";
      item.appendChild(summary);
      var list = document.createElement("table");
      list.className = "fitment-accordion__table";
      var head = list.createTHead().insertRow();
      data.headers.forEach(function (heading) {
        var th = document.createElement("th");
        th.scope = "col";
        th.textContent = label(heading);
        head.appendChild(th);
      });
      var body = list.createTBody();
      group.rows.forEach(function (row) {
        var tr = body.insertRow();
        row.forEach(function (value) { tr.insertCell().textContent = value; });
      });
      item.appendChild(list);
      accordion.appendChild(item);
    });
    wrapper.parentNode.insertBefore(accordion, wrapper);
    wrapper.classList.add("table-wrapper--has-accordion");
    // Rich text editor leftovers: a fixed height turns the wrapper into a scroll box.
    table.style.height = "";
    table.querySelectorAll("tr, th, td").forEach(function (cell) { cell.style.height = ""; });
  }

  document.querySelectorAll(".rte table.table-accordion").forEach(function (table) {
    var data = readTable(table);
    if (data) build(table, data);
  });
})();
